import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud-service';
import {TipoInstitucionInterface} from '../interfaces/utilidades/tipo-institucion.interface';

@Injectable({
  providedIn: 'root'
})

export class TipoInstitucionService extends CrudService<TipoInstitucionInterface> {
  constructor(http: HttpClient) {
    super(http, 'https://camposdeportivos.muninuevochimbote.gob.pe/api/tipo-institucion'); // Cambia esta URL según tu API
  }

}
